import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Button,
	InputAdornment,
	TextField,
	TextareaAutosize,
	Typography,
} from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { SERVER_URI } from "../../utils/config"
import { ConfirmFinalization } from "./ConfirmFinalization"
import { SinglePhase } from "./SinglePhase"

export const ReceivedOrder = () => {
	const orderId = useParams().id
	const [order, setOrder] = useState(null)
	const [packageData, setPackageData] = useState(null)
	const [isLoaded, setIsLoaded] = useState(false)
	const [orderExtraInfo, setOrderExtraInfo] = useState("")
	const [packageExtraInfo, setPackageExtraInfo] = useState([])
	const [fixedPrice, setFixedPrice] = useState(0)
	const [openConfirm, setOpenConfirm] = useState(false)

	useEffect(() => {
		// Fetch order data from the API
		const fetchData = async () => {
			let packageId = null
			try {
				const response = await axios.get(`${SERVER_URI}/get_received_order/${orderId}`)
				setOrder(response.data.order)
				packageId = response.data.order.servicepackageid
				if (response.data.order.extrainfo) {
					setOrderExtraInfo(response.data.order.extrainfo)
				}

				if (response.data.order.fixed_price) {
					setFixedPrice(response.data.order.fixed_price)
				}

				// Fetch package data
				const packageResponse = await axios.get(`${SERVER_URI}/get_package/${packageId}`)
				setPackageData(packageResponse.data.servicePackage)

				// Fetch extrainfos
				const extrainfoResponse = await axios.get(`${SERVER_URI}/get_extrainfos/${orderId}`)
				setPackageExtraInfo(extrainfoResponse.data.extrainfos)

				setIsLoaded(true)
			} catch (error) {
				console.error(error)
			}
		}
		fetchData()
	}, [orderId])

	const calculateTotal = () => {
		let total = 0
		order.orderlines.forEach((orderline) => {
			if (orderline.costperunit !== null) {
				total += orderline.costperunit
			}
		})

		packageData.phases.forEach((phase) => {
			phase.services.forEach((service) => {
				if (service.costperunit !== null) {
					total += service.costperunit
				}
				/* service.servicequestions.forEach(question => {
          if(question.costperunit !== null)
          {
            total += question.costperunit
          }
        }) */
			})
		})
		return total
	}

	const handleUpdateOrderInfo = async () => {
		try {
			await axios.post(`${SERVER_URI}/update_order_info/${orderId}`, {
				orderinfoid: order.orderinfoid,
				extrainfo: orderExtraInfo,
				fixed_price: fixedPrice,
			})
		} catch (error) {
			console.error(error)
		}
	}

	const handleNumberChange = (event) => {
		const regex = /^\d*\.?\d{0,2}$/
		if (regex.test(event.target.value) || event.target.value === "") {
			setFixedPrice(event.target.value)
		}
	}

	const handleFinalizeOrder = () => {
		setOpenConfirm(true)
	}

	return (
		<Box>
			{isLoaded && (
				<>
					<Box sx={{ textAlign: "center" }}>
						<Typography variant="h2">{packageData.title}</Typography>
						{/* <Typography variant="h2">{calculateTotal()} €</Typography> */}
					</Box>

					<Accordion sx={{ mt: 2 }}>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography variant="h3">Tilaajan tiedot</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Typography variant="h4">Nimi: {order.name}</Typography>
							<Typography variant="h4">Sähköposti: {order.email}</Typography>
							<Typography variant="h4">Puhelin: {order.phonenr}</Typography>
						</AccordionDetails>
					</Accordion>

					{packageData.phases.map((phase) => (
						<SinglePhase key={phase.phaseid} phase={phase} order={order} packageExtraInfo={packageExtraInfo} />
					))}
					<Box>
						<Accordion sx={(theme) => ({ backgroundColor: theme.palette.contrast.main, borderTop: "2px solid black" })}>
							<AccordionSummary expandIcon={<ExpandMoreIcon />}>
								<Typography variant="h3">Lisätiedot</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<TextareaAutosize
									aria-label="empty textarea"
									placeholder="Lisätiedot"
									style={{ fontFamily: "system-ui", width: "100%", fontSize: "1.5rem", resize: "none" }}
									minRows={3}
									maxRows={10}
									value={orderExtraInfo}
									onChange={(e) => setOrderExtraInfo(e.target.value)}
								/>
								<Button variant="contained" color="primary" sx={{ mt: 1 }} fullWidth onClick={handleUpdateOrderInfo}>
									Tallenna lisätiedot
								</Button>
							</AccordionDetails>
						</Accordion>
					</Box>
					<Box>
						<Accordion sx={(theme) => ({ backgroundColor: theme.palette.contrast.main, borderTop: "2px solid black" })}>
							<AccordionSummary expandIcon={<ExpandMoreIcon />}>
								<Typography variant="h3">Hinnan määrittely</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
									<Typography variant="h5">Laskettu hinta</Typography>
									<Typography variant="h5">{calculateTotal()} €</Typography>
								</Box>
								<TextField
									name="price"
									label="Hinnan määrittely"
									variant="standard"
									color="oma"
									fullWidth
									sx={{ mt: 1 }}
									InputProps={{
										style: { fontFamily: "system-ui", fontSize: "1.5rem", textAlign: "right" },
										inputProps: {
											style: { fontFamily: "system-ui", fontSize: "1.5rem", textAlign: "right" },
										},
										endAdornment: (
											<InputAdornment position="end">
												<Typography variant="h5" sx={{ color: "black" }}>
													€
												</Typography>
											</InputAdornment>
										),
									}}
									value={fixedPrice}
									onChange={handleNumberChange}
								/>
								<Button variant="contained" color="primary" sx={{ mt: 1 }} fullWidth onClick={handleUpdateOrderInfo}>
									Tallenna määrittely
								</Button>
							</AccordionDetails>
						</Accordion>
					</Box>
					<Button variant="contained" color="primary" sx={{ mt: 4 }} fullWidth onClick={handleFinalizeOrder}>
						Viimeistele tilaus / Lähetä lasku
					</Button>
				</>
			)}
			<ConfirmFinalization open={openConfirm} setOpen={setOpenConfirm} />
		</Box>
	)
}
